import { Navigate, generatePath, useLocation, useParams } from 'react-router-dom'
import queryString from 'query-string'

interface IProps {
  // Target route template (e.g. ROUTES.ORGANIZATION_PAGE). Any `:param` is filled
  // from the current route's params, so a legacy `/entity/:id` can redirect to
  // `/organization/:id` without losing the id.
  to: string
  search?: Record<string, string>
}

const RouteRedirect = ({ to, search }: IProps) => {
  const params = useParams()
  const location = useLocation()
  const target = generatePath(to, params)
  // The incoming query and hash are carried over — a legacy URL is a link somebody
  // followed, and its params are what makes it land somewhere useful. `search` is
  // applied on top so the redirect's own discriminator (`source`) always wins.
  const qs = queryString.stringify({
    ...queryString.parse(location.search),
    ...search,
  })
  return <Navigate to={`${target}${qs ? `?${qs}` : ''}${location.hash}`} replace />
}

export default RouteRedirect
